'use client';

import Image from 'next/image';

export default function GrowthSchoolWay() {
  return (
    <div className="w-full py-10 md:py-16 bg-white">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Heading Section */}
        <div className="mb-8 md:mb-12">
          <p className="text-sm md:text-base text-[#002726] font-medium uppercase tracking-wide mb-2">
            WHERE PASSION, INNOVATION AND FUN COLLIDE
          </p>
          <h2 className="text-3xl md:text-4xl font-medium text-[#002726]">
            The GrowthSchool Way
          </h2>
        </div>
        
        {/* Image Section - rounded with overlay */}
        <div className="relative w-full h-[200px] md:h-[650px] rounded-3xl overflow-hidden">
          <Image
            src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/imgpeop.png" // Update to your actual image path
            alt="GrowthSchool Team"
            fill
            className="object-cover"
          />
      
        </div>
      </div>
    </div>
  );
}